export const getErrorMessage = (message: string | undefined) => {
  return message || 'Не удалось обработать платёж. Попробуйте повторить позже.';
};
